import { Layout } from 'antd';
import React from 'react';
import { Switch, Route, RouteProps, RouteComponentProps } from 'react-router-dom';

import Content from '@/Layout/components/Content';
import Sider from '@/Layout/components/Sider';
import GachaContext from '@/hooks/context/GachaContext';
import GiftCodeCryptContext from '@/hooks/context/GiftCodeCryptContext';

export type IndividualGachaComponentProps = RouteComponentProps<{ gachaId: string }> & {
  routes: RouteProps[];
};

const IndividualGachaRouter: React.FC<IndividualGachaComponentProps> = ({ match, routes }) => (
  <Layout>
    <GachaContext gachaId={match.params.gachaId}>
      <GiftCodeCryptContext>
        <Sider />
        <Content>
          <Switch>
            {routes.map((route, i) => (
              // eslint-disable-next-line react/jsx-props-no-spreading, react/no-array-index-key
              <Route key={i} {...route} />
            ))}
          </Switch>
        </Content>
      </GiftCodeCryptContext>
    </GachaContext>
  </Layout>
);

export default IndividualGachaRouter;
